/**
 * 모바일 전용 config
 */
 let mobileConfig = {
  main: {
    list: {
      url: '/api/main/mobile/lists',
    }
  },
  sop: {
    min: {
      safetycheck: {
        get: {
          url: "/api/sop/min/safetycheck/plan/mobile/{0}"
        }
      },
      equipment: {
        plan: {
          daily: {
            get: {
              mobile: {
                url: "/api/sop/min/equipment/daily/plan/mobile"
              },
              equipment: {
                url: "/api/sop/min/equipment/daily/plan/equipment/{0}"
              }
            }
          },
          deterior: {
            get: {
              mobile: {
                url: "/api/sop/min/equipment/deterior/plan/mobile"
              },
              equipment: {
                url: "/api/sop/min/equipment/deterior/plan/equipment/{0}"
              }
            },
          }
        },
        result : {
          daily: {
            resultFind: {
              url: "/api/sop/min/equipment/daily/result/find"
            }
          },
          deterior: {
            resultFind: {
              url: "/api/sop/min/equipment/deterior/result/find"
            }
          },
          lunar: {
            url: "/api/sop/min/equipment/lunar/{0}"
          }
        },
      },
    },
    edu: {
      plan: {
        update: {
          targetUser: {
            signature: {
              url: "/api/sop/edu/result/targetuser/signature"
            }
          }
        },
      },
      result: {
        get: {
          mobile: {
            url: "/api/sop/edu/result/mobile/{0}/{1}"
          }
        },
      },
    },
  }  
};

export default mobileConfig;
